<template>
    <div>
        <div class="info-box">
            <div class="info-title">
                <h3>基本信息</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box">
                    <p><span style="color:red;margin-right:0.3rem"> *</span>月份：</p>
                    <a-month-picker
                        :disabled="type=='edit'"
                        class="input"
                        valueFormat="YYYY-MM"
                        v-model="info.issuingMonth"
                        >
                    </a-month-picker>
                </div>
                <div class="input-box">
                    <p><span style="color:red;margin-right:0.3rem"> *</span>姓名：</p>
                    <a-select
                        mode="tags"
                        :disabled="type=='edit'"
                        class="input" 
                        allowClear
                        show-search
                        :filter-option="filterOption"
                        v-model="info.teacherName"
                        @change="teacherSelect"
                        option-label-prop="label">
                        <a-select-option v-for="(item,index) in jsArr" :key="index" :value="item.teacherName" :label="item.teacherName">{{item.teacherId}}-{{item.teacherName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p><span style="color:red;margin-right:0.3rem"> *</span>工号：</p>
                    <a-input class="input" v-model="info.teacherId" :disabled="type=='edit'"/>
                </div>
                <div class="input-box">
                    <p>部门：</p>
                    <a-input class="input" v-model="info.orgName" :disabled="type=='edit'"/>
                </div>
                <div class="input-box">
                    <p>职称：</p>
                    <a-input class="input" v-model="info.technicalTitleName" :disabled="type=='edit'"/>
                </div>
            </div>
            <div class="info-title">
                <h3>工资发放</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box">
                    <p>每月实发：</p>
                    <a-input-number class="input" v-model="info.actualAmount" />
                </div>
                <div class="input-box">
                    <p>专项奖励：</p>
                    <a-input-number class="input" v-model="info.specialAward" />
                </div>
                <div class="input-box">
                    <p>奖励/课酬：</p>
                    <a-input-number class="input" v-model="info.rewardAmount" />
                </div>
                <div class="input-box">
                    <p>饭贴：</p>
                    <a-input-number class="input" v-model="info.riceSubsidy" />
                </div>
                <div class="input-box">
                    <p>补发：</p>
                    <a-input-number class="input" v-model="info.backpayAmount" />
                </div>
                <div class="input-box">
                    <p>扣发：</p>
                    <a-input-number class="input" v-model="info.garnishedWages" />
                </div>
                <div class="input-box">
                    <p>其他：</p>
                    <a-input-number class="input" v-model="info.other" />
                </div>
                <div class="input-box">
                    <p>应发合计：</p>
                    <a-input-number class="input" v-model="info.totalAmount" disabled/>
                </div>
                <div class="input-box input-box-large">
                    <p>备注：</p>
                    <a-textarea class="input" :rows="3" v-model="info.comments" />
                </div>
            </div>
        </div>
        <div class="btn-box">
            <a-button type="primary" v-if="type=='add'" @click="sub">保存</a-button>
            <a-button type="primary" v-if="type=='edit'" @click="sub('edit')">保存</a-button>
            <a-button type="primary" v-if="type=='edit'" @click="sub('approval')">调整</a-button>
            <a-button @click="$router.go(-1)">返回</a-button>
        </div>
    </div>
</template>
<script>
    import { add,edit,approved} from '@/baseAPI/payroll'
    import { getDicts } from '@/baseAPI/dictionary'
    import { getTeacher } from '@/baseAPI/facultyTeacher'

    export default {
        name: '',
        data () {
            return {
                type:'',
                info:{
                    id:"",
                    orgCode: "",
                    orgName: "",
                    teacherId: "",
                    // teacherName: "",
                    technicalTitleCode: "",
                    issuingMonth: "",
                    actualAmount: null,
                    specialAward: null,
                    rewardAmount: null,
                    riceSubsidy: null,
                    backpayAmount: null,
                    garnishedWages: null,
                    totalAmount: null,
                    other:null,
                    comments: "",
                },
                xbArr:[],
                jsArr:[],
                zyArr:[],
            }
        },
        mounted () {
            this.type=this.$route.params.type;
            if(this.type == 'edit'){
                this.info=JSON.parse(this.$route.params.info);
            }
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
            })
            getDicts({dataCode:'BKZY',status:true}).then(res=>{
                this.zyArr=res.data.dicts;
            })

            getTeacher().then(res=>{
                this.jsArr=res.data;
            })
            Math.formatFloat = function (f, digit) {  // 解决js精度丢失问题
                var m = Math.pow(10, digit);
                return Math.round(f * m, 10) / m;
            }
            if(this.type == 'add'){
                this.info.issuingMonth=this.getYearMonth()
            }

            // if(this.type!='add'){
            //     setTimeout(()=>{
            //         info(this.$route.query.id).then(res=>{
            //             this.info=res.data;
            //             this.data=res.data.inspectDetails

            //             var totalScore=0.0
            //             this.data.forEach((item,index)=>{
            //                 if(item.indexScore != '' && item.indexScore !=null && index < 13){
            //                     totalScore += parseFloat(item.indexScore)
            //                 }
            //             })
            //             this.data[13].indexScore = totalScore 
            //             console.log("indexScore:"+this.data[13].indexScore)
            //         })
            //     },500)
            // }
        },
        watch:{
            info:{
                handler(newVal){
                    if(this.type != 'look'){
                        this.totalAmount()
                    }
                },
                deep: true
            }
        },
        methods:{
            getYearMonth(){
                let month = new Date().getMonth()+1;
                let year = new Date().getFullYear();
                return month < 10 ? (year + '-0' + month) : (year + '-' + month)
            },
            totalAmount(){
                this.info.actualAmount == null ? this.info.actualAmount = 0 : ''
                this.info.specialAward == null ? this.info.specialAward = 0 : ''
                this.info.rewardAmount == null ? this.info.rewardAmount = 0 : ''
                this.info.riceSubsidy == null ? this.info.riceSubsidy = 0 : ''
                this.info.backpayAmount == null ? this.info.backpayAmount = 0 : ''
                this.info.garnishedWages == null ? this.info.garnishedWages = 0 : ''
                this.info.other == null ? this.info.other = 0 : ''
                this.info.totalAmount = Math.formatFloat(parseFloat(this.info.actualAmount) + parseFloat(this.info.specialAward)
                                        + parseFloat(this.info.rewardAmount) + parseFloat(this.info.riceSubsidy)
                                        + parseFloat(this.info.backpayAmount) - parseFloat(this.info.garnishedWages)
                                        + parseFloat(this.info.other),2);
            },
            check(){
                if(this.info.studentNo != "" && this.info.checkType !=""){
                    check({checkType:this.info.checkType,studentNo:this.info.studentNo}).then(res=>{
                        if(res.data.success){
                            // this.$notification['success']({
                            //     message: '成功',
                            //     description:'校验通过',
                            // });
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                    })
                }
            },
            teacherSelect(value){
                value = value[0]
                for(let i=0;i<this.jsArr.length;i++){
                    if(this.jsArr[i].teacherName==this.info.teacherName){
                        this.info.orgName=this.jsArr[i].orgName
                        this.info.orgCode=this.jsArr[i].orgCode
                        this.info.teacherId=this.jsArr[i].teacherId
                        this.info.teacherName=this.jsArr[i].teacherName
                        this.info.technicalTitleCode=this.jsArr[i].technicalTitleCode
                        this.info.technicalTitleName=this.jsArr[i].technicalTitleName
                    }
                }
                if(this.info.teacherName == null || this.info.teacherName==''){
                    this.info.teacherName = value
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            sub(type){
                if(this.info.teacherName !=null && this.info.teacherName.constructor==Array && this.info.teacherName.length >= 1){
                    this.info.teacherName = this.info.teacherName[0]
                }
                var isSub=true;
                var arr=['teacherId','teacherName','issuingMonth']
                for(let i=0;i<arr.length;i++){
                    if(this.info[arr[i]]==null||this.info[arr[i]]===''){
                        isSub=false;
                        break;
                    }
                }
                if(isSub){
                    if(this.type=='add'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'保存工资发放成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        if(this.type=='edit'){
                            edit(this.info).then(res=>{
                                if(res.data.success){
                                    this.$notification['success']({
                                        message: '成功',
                                        description:'保存工资发放成功',
                                    });
                                    if(type=='approval'){
                                        approved([this.info.id]).then(res=>{
                                            if(res.data.success){
                                                this.$notification['success']({
                                                    message: '成功',
                                                    description:'调整工资发放成功',
                                                });
                                            }else{
                                                this.$notification['error']({
                                                    message: '失败',
                                                    description:res.data.errorMessage,
                                                });
                                            }
                                        })
                                    }
                                    this.$router.go(-1)
                                }else{
                                    this.$notification['error']({
                                        message: '失败',
                                        description:res.data.errorMessage,
                                    });
                                }
                            })
                        }
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }

    .info-main .table{
        margin-left: 10rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }

    .pyr{
        justify-content: flex-end;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        margin-right: 12rem;
        /* position: relative; */
    }

    .info-main .input-box-center{
        width: 66%;
    }

    .info-main .input-box-large{
        width: 99%;
    }

    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 10rem);
    }
    .info-main .input-box .radio{
        width: calc(100% - 10rem);
    }
    .info-main .input-box .tips{
        width: calc(100% - 11rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .input >>> .ant-input[disabled],
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .standard{
        width: 28px;
        height: 100px;
        position: absolute;
        right: 0;
        top: 200px;
        text-align: center;
        border-radius: 6px 0 0 6px !important;
        z-index: 0;
        pointer-events: auto;
        cursor: pointer;
        color: rgb(255, 255, 255);
        background-color: #245086;
        opacity: 0.8;
        padding: 2px 0px 0px 0px;
    }

    .standard:hover{
        opacity: 1;
    }

    .info-main .input-maxbox{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
    }

    .info-main .input-maxbox p{
        width: 10rem;
        text-align: right;
    }

    .info-main .input-maxbox .textarea{
        width: calc(100% - 10rem);
    }

    .info-main .input-notes{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
    }

    .info-main .input-notes .notes{
        width: calc(100% - 10rem);
        text-align: left;
        font-size: 0.9rem;
    }

    .info-main .input-notes .note-title{
        width: 10rem;
        text-align: right;
        font-size: 0.9rem;
        font-weight: bolder;
        color: black;
    }

</style>
